import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Popover } from '@material-ui/core';
import { MdAdd } from 'react-icons/md';
import { FaUserTie } from 'react-icons/fa';

import Paper from 'components/Paper';
import { LoadingPage } from 'components/Loading';
import SearchInput from 'components/SearchInput';
import Table from 'components/Table';
import { Row } from 'styles/components';
import EmbarcadoresActions from 'store/ducks/embarcadores';

import {
  Container,
  WrapperTable,
  WrapperAdd,
  DeleteIcon,
  EditIcon,
  ViewIcon,
  WrapperPopover,
  PopoverText,
  PopoverButton,
} from './styles';

export default function Embarcadores() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { embarcadores, isLoading } = useSelector((state) => state.embarcadores);

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    dispatch(EmbarcadoresActions.getEmbarcadoresRequest());
  }, [dispatch]);

  if (isLoading) {
    return <LoadingPage />;
  }

  const data = (embarcadores || []).map((e) => ({
    ...e,
    actions: e.id,
    nome: e.nome || '-',
    nomeFantasia: e.nomeFantasia || '-',
    cpfCnpj: e.cpfCnpj || '-',
    cidadeUf: `${e.cidade || ''}${e.uf ? ' - ' + e.uf : ''}`.trim() || '-',
  }));

  const filteredData = data.filter(
    (item) =>
      (item.nome || '').toUpperCase().includes(search.toUpperCase()) ||
      (item.nomeFantasia || '').toUpperCase().includes(search.toUpperCase()) ||
      (item.cpfCnpj || '').includes(search)
  );

  const handleDelete = () => {
    if (selectedId) {
      dispatch(EmbarcadoresActions.removeEmbarcadorRequest(selectedId));
      setOpen(false);
      setAnchorEl(null);
    }
  };

  return (
    <Container>
      <Paper
        title="EMBARCADORES"
        icon={<FaUserTie size={24} style={{ color: '#122d58', marginRight: '25px' }} />}
        rightContent={
          <Row>
            <SearchInput
              onChange={(e) => setSearch(e.target.value)}
              onClear={() => setSearch('')}
              value={search}
            />
            <WrapperAdd>
              <div
                onClick={() => history.push('/embarcadores/new')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  height: '36px',
                  minWidth: '120px',
                  padding: '0 20px',
                  backgroundColor: '#FFF28D',
                  boxShadow: '0px 3px 6px #00000029',
                  borderRadius: '3px',
                  fontSize: '12px',
                  fontWeight: 600,
                  color: '#122d58',
                  transition: 'all 0.2s ease',
                }}
              >
                <MdAdd size={20} style={{ marginRight: '10px', color: '#122d58' }} />
                Novo
              </div>
            </WrapperAdd>
          </Row>
        }
      >
        <WrapperTable>
          <Table
            columns={[
              { label: 'Ações', id: 'actions' },
              { label: 'Nome', id: 'nome' },
              { label: 'Nome Fantasia', id: 'nomeFantasia' },
              { label: 'CPF/CNPJ', id: 'cpfCnpj' },
              { label: 'Cidade/UF', id: 'cidadeUf' },
            ]}
            activePage={0}
            totalPages={Math.ceil(filteredData.length / 10) || 1}
            data={filteredData}
            customComponent={{
              actions: (id) => (
                <Row>
                  <ViewIcon
                    onClick={() => history.push(`/embarcadores/view/${id}`)}
                    style={{ marginRight: '10px' }}
                  />
                  <EditIcon
                    onClick={() => history.push(`/embarcadores/edit/${id}`)}
                    style={{ marginRight: '10px' }}
                  />
                  <DeleteIcon
                    onClick={(ev) => {
                      setSelectedId(id);
                      setAnchorEl(ev.currentTarget);
                      setOpen(true);
                    }}
                  />
                </Row>
              ),
            }}
          />
        </WrapperTable>
      </Paper>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => {
          setOpen(false);
          setAnchorEl(null);
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <WrapperPopover>
          <PopoverText>Tem certeza que deseja excluir?</PopoverText>
          <Row>
            <PopoverButton onClick={handleDelete} primary>
              Sim
            </PopoverButton>
            <PopoverButton
              onClick={() => {
                setOpen(false);
                setAnchorEl(null);
              }}
            >
              Não
            </PopoverButton>
          </Row>
        </WrapperPopover>
      </Popover>
    </Container>
  );
}


